class BESSAppAccountTrainingPreferences extends BESSAppBase {


    constructor() {
        super();
        this.root = $('.app-account-training-preferences');
        if (this.root.length === 0) {
            return;
        }
        this.input = this.root.find('#id_training_show');
        this.input.change(this.#updatePreference.bind(this));
    }

    #updatePreference() {
        let val = this.input.val();
        let setting = ('' + this.input.val()) === '1';
        BESSApp.instance.services.api.auth.updateUserTrainingPreference(setting);
    }
}